import React from 'react';
import './back-button.css';
import { useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material';


const BackButton: React.FC = () => {
    const navigate = useNavigate();

    const theme = useTheme();
    

    return (
        <>
            <div className="back_button_container" onClick={() => navigate(-1)}>
                <div className="back_button_left_arrow">
                    <div className="back_button_image" style={{filter: theme.palette.mode === 'dark' ? 'brightness(0) invert(1)' : 'none'}}></div>
                </div>
                <div className="back_button_text">
                    Back
                </div>
            </div>
        </>
    )
}

export default BackButton;